import EDC from '../../../shared/globals';

EDC.Animations.Clouds = function (scene) {
  this.scene = scene;
  this.speedGroups = [];

  this.cloudsNames = [
    'cloud_1',
    'cloud_2',
    'cloud_3',
  ];

  this.speeds = [
    30000,
    18000,
    11000,
  ];
};

EDC.Animations.Clouds.prototype.start = function () {
  for (let i = 0; i < this.speeds.length; i++) {
    this.speedGroups.push(this.scene.add.container(0, 0));
  }
  this.generateCloud();
};

EDC.Animations.Clouds.prototype.generateCloud = function () {
  const rndImgIndex = Math.floor(Math.random() * this.cloudsNames.length);
  const cloud = this.scene.add.sprite(-430,
    this.getRandomHeight(), this.cloudsNames[rndImgIndex]).setOrigin(0);

  const rndIndex = Math.floor(Math.random() * this.speeds.length);
  const speed = this.speeds[rndIndex];
  const targetGroup = this.speedGroups[rndIndex];

  targetGroup.add(cloud);

  this.scene.tweens.add({
    targets: cloud,
    x: this.scene.game.config.width + cloud.width,
    duration: speed,
    ease: 'Linear',
    onComplete: this.destroyCloud.bind(this, cloud),
  });

  this.generateCloudAfterRandomTime();
};

EDC.Animations.Clouds.prototype.generateCloudAfterRandomTime = function () {
  const time = 1000 * 3 + Math.round(Math.random() * (1000 * 6));
  this.scene.time.addEvent({ delay: time, callback: this.generateCloud, callbackScope: this });
};

EDC.Animations.Clouds.prototype.getRandomHeight = function () {
  const min = 20;
  const max = 350;
  const height = min + Math.round(Math.random() * max);
  return height;
};

EDC.Animations.Clouds.prototype.destroyCloud = function (cloud) {
  cloud.destroy();
};

export default EDC.Animations.Clouds;
